import React, { useState, useEffect } from 'react';
import { Progress, Group, Text } from '@mantine/core';

interface ProgressBarProps {
  message: string;
  durationInSeconds?: number;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ message, durationInSeconds = 5 }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = 100; // Update every 100ms for smooth animation
    const totalSteps = (durationInSeconds * 1000) / interval;
    const increment = 100 / totalSteps;

    const timer = setInterval(() => {
      setProgress(prevProgress => {
        if (prevProgress >= 100) {
          clearInterval(timer);
          return 100;
        }
        return prevProgress + increment;
      });
    }, interval);

    return () => clearInterval(timer);
  }, [durationInSeconds]);

  return (
    <Group gap="xs" py="md">
      <Progress value={progress} size="sm" radius="xl" style={{ width: '100%' }} />
      <Text size="sm" c="dimmed">
        {message}
      </Text>
    </Group>
  );
};
